/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type CommunicationsStatusPagePreviewEntrypointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const communicationsStatusPagePreviewEntrypoint: EntryPoint<
	CommunicationsStatusPagePreviewEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<CommunicationsStatusPagePreviewEntrypointComponent>(
		/* webpackChunkName: "async-communications-status-page-preview-entrypoint" */ './ui/StatuspagePreviewPage.tsx',
	),
	getPreloadProps: () => {
		return {};
	},
});
